import axiosInstance from "shared/axios";
import { OUTBOND_PAYMENT_API } from "shared/constants";

export const outbondPayment = (data) => {
  let url =  `${OUTBOND_PAYMENT_API.listing}`;
  return axiosInstance.post(url,data);
};

export const fetchDropDownData = () =>{
    let url = `${OUTBOND_PAYMENT_API.dropDown}`
    return axiosInstance.get(url)
  }

  export const onSearchListing = (data) =>{
    let url =  `${OUTBOND_PAYMENT_API.listing}`;
    return axiosInstance.post(url,data);
  }

  export const fetchReEnqireData = (data) =>{
    let url = `${OUTBOND_PAYMENT_API.ReEnqire}`;
    return axiosInstance.post(url,data)
  }

  export const paymentStatusChange = (data) =>{
    let url = `${OUTBOND_PAYMENT_API.statusChange}`;
    return axiosInstance.post(url,data)
  }
  export const viewBankDetails = (userBankReferenceNumber) => {
    let url = `${OUTBOND_PAYMENT_API.viewBank}/${userBankReferenceNumber}`;
    return axiosInstance.get(url);
  };

  export const fetchOutBondListing = (data) => {
    let fullParam =`${OUTBOND_PAYMENT_API.listing}`;
    return axiosInstance.post(fullParam,data);
    };